module.exports = __webpack_public_path__ + "media/images/icons/chevron-down-539014e1184554febb934148d869a43d.svg";